import type { ComputeBboxStrokeWidth } from "./types";

/**
 * Returns the stroke width in SVG coord units. The SVG `<g scale(zoom)>`
 * transform then renders it as `screenPx = strokePxAtMaxZoom * min(1, zoom / maxZoom)`
 * — capped at `strokePxAtMaxZoom` and scaling down proportionally below max zoom.
 */
export const computeBboxStrokeWidth: ComputeBboxStrokeWidth = ({
  zoomLevel,
  maxZoom,
  strokePxAtMaxZoom,
}) => {
  const screenPx = strokePxAtMaxZoom * Math.min(1, zoomLevel / maxZoom);
  return screenPx / zoomLevel;
};
